import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.step"],
  step => step
);
